import { render, staticRenderFns } from "./services_page3.vue?vue&type=template&id=575146e6&"
import script from "./services_page3.vue?vue&type=script&lang=js&"
export * from "./services_page3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports